import { render, staticRenderFns } from "./bolseirosListagemRevogados.vue?vue&type=template&id=0466763c&scoped=true&"
import script from "./bolseirosListagemRevogados.vue?vue&type=script&lang=js&"
export * from "./bolseirosListagemRevogados.vue?vue&type=script&lang=js&"
import style0 from "./bolseirosListagemRevogados.vue?vue&type=style&index=0&id=0466763c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0466763c",
  null
  
)

export default component.exports